import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ReactMarkdown from 'react-markdown';

const DocsPage: React.FC = () => {
  const { token } = useAuth();
  const [content, setContent] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const res = await fetch('/docs/browser-monitor');
        if (!res.ok) throw new Error(`Failed to load doc: ${res.status}`);
        const text = await res.text();
        setContent(text);
      } catch (err: any) {
        setError(err.message || 'Failed to load documentation');
      }
    };
    fetchDoc();
  }, [token]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Browser Monitor Documentation</h2>
      {error && <div className="alert alert-error mb-4">{error}</div>}
      {content ? (
        <div className="prose max-w-none">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      ) : (
        <div className="text-base-content/70">Loading...</div>
      )}
    </div>
  );
};

export default DocsPage;
